//#region import
import React, { useCallback, useContext, useEffect, useMemo, useRef, useState } from 'react';
import { Divider, Grid, Stack, Tooltip, Typography } from '@mui/material';
import { ProjectContext } from '../../ProjectRequestFrom';
import { Convert, ConvertDateToUnixOrNull, FnAxios, FnDialog, I18n, ParseHtml, RouterDOM, formatNumber } from 'utilities/utilities';
import { APIStatusCode, EnumProjectStatusFinalScore, EnumProjectStatusID, EnumSaveModeProject, I18NextNs } from 'enum/enum';
import { useLocation, useNavigate } from 'react-router';
import { ApiProject } from 'enum/api';
import UploadFileItem from 'components/Input/UploadFile';
import { FormProvider, useForm } from 'react-hook-form';
import { BtnApprove, BtnCancel, BtnDraft, BtnEdit, BtnSave, BtnSendRequest } from 'components/Button/ButtonAll';
import { DatePickerItem } from 'components/Input/DatePicker/DatePickerItem';
import moment from 'moment';
import InputNumberItem from 'components/Input/InputNumber';
import { TextAreaItem } from 'components/Input/TextArea';
import ContentWrapper from '../../components/ContentWrapper';
import ModalRemark from '../../components/Modal/ModalRemark';
import DialogPreview from 'components/DialogPreview/DialogPreview';
//#endregion

const CloseProject = () => { //กท3 > กท3/2 ปิดโครงการ
    const { 
        nProjectID,
        isFastTrack,
        isPermission,
        nStatusID,
        isModeSecretary,
        sPathNameBack,
        ObjStepFlowProject,
        sMode,
        nProgressStatusID,
        isChangeUpdateProgress,
        setisChangeUpdateProgress,        
    } = useContext(ProjectContext);

    const AxiosFn = FnAxios();
    const DialogFn = FnDialog();
    const location = useLocation();
    const navigate = useNavigate();
    const Router = RouterDOM();    

    //#region useState
    const [isEdit, setisEdit] = useState(false);
    const [isEditSecretary, setisEditSecretary] = useState(null);
    const [dProjectStart, setdProjectStart] = useState(null);
    const [ObjDataProject, setObjDataProject] = useState(null);

    const onClearFile = useRef(null);
    const [lstFileCloseProject, setlstFileCloseProject] = useState([]);

    const [isModalRecallClose, setisModalRecallClose] = useState(false);
    // const [sRemark, setsRemark] = useState(null);    

    // const [isBtn_DraftClose, setisBtn_DraftClose] = useState(true); //Requester >> บันทึกร่าง
    // const [isBtn_SendClose, setisBtn_SendClose] = useState(true); //Requester | ผู้ประสานงาน >> หัวหน้าโครงการ >> บันทึกปิดโครงการ
    // const [isBtn_ConfirmSendClose, setisBtn_ConfirmSendClose] = useState(false); //หัวหน้าโครงการ >> ยืนยันปิดโครงการ
    // const [isBtn_ConfirmClose, setisBtn_ConfirmClose] = useState(false); //เลขา >> ยอมรับผลและปิดโครงการ
    //#endregion

    const formRemark = useForm({
        shouldFocusError: true,
        mode: "all",
        defaultValues: {
            sRemark: null,
        } as any,
    });

    const form = useForm({
        shouldFocusError: true,
        mode: "all",
        defaultValues: {
            dCloseProject: null,
            nProjectActualDay: null,
            sCloseOperatingResults: null,
            sCloseManageSustainable: null,
            sCloseIssue: null,
        } as any,
    });

    useEffect(() => {
        if (nProjectID !== 0) GetFormInitial();
    }, [nProjectID]);

    useEffect(() => {
        setisEditSecretary(isModeSecretary === true ? false : isPermission);
    }, [isModeSecretary]);
  
    // const _isEditSecretary = useMemo(() => {
    //     let _isEdit = (nProgressStatusID === EnumProjectStatusID.nStatusID_28 && isEditSecretary === true) ? false : !isEdit;
    //     return _isEdit;
    // }, [isEdit, isEditSecretary, nStatusID])

    // useEffect(() => {
    //     if (isChangeUpdateProgress === true) window.location.reload(); //GetFormInitial();
    // }, [isChangeUpdateProgress]); 

    const GetFormInitial = () => {
        AxiosFn.Get(ApiProject.GetFormProjectClose, { nProjectID : nProjectID }, (result) => {            
            setdProjectStart((result.dProjectStart ? moment(result.dProjectStart) : null));
            setObjDataProject(result.ObjDataProject);
        });
    }

    useEffect(() => {
        if (ObjDataProject !== null) {
            form.setValue("dCloseProject", (ObjDataProject?.nDateCloseProject ? moment(ObjDataProject?.nDateCloseProject) : null)); //วัน/เดือน/ปี ที่สิ้นสุด (กรอกเอง)
            form.setValue("nProjectActualDay", ObjDataProject?.nProjectActualDay); //ระบุจำนวนวัน << จำนวนวันที่ดำนเนินโครงการ (ระบุตอนปิดโครงการ) (กรอกเอง) 
            form.setValue("sCloseOperatingResults", ObjDataProject?.sCloseOperatingResults); //ผลการดำเนินงาน (กรอกเอง) < TbProjectData
            form.setValue("sCloseManageSustainable", ObjDataProject?.sCloseManageSustainable); //แนวทางการบริหารโครงการเพื่อให้เกิดความต่อเนื่องและยั่งยืน (กรอกเอง) < TbProjectData
            form.setValue("sCloseIssue", ObjDataProject?.sCloseIssue); //ปัญหา/อุปสรรคที่เกิดขึ้นหลังเสร็จสิ้นโครงการ และแนวทางแก้ไข (กรอกเอง) < TbProjectData
            setlstFileCloseProject(ObjDataProject?.lstFileCloseProject ?? []);
        }
    }, [ObjDataProject]);

    const handleSubmit = (nModeID: EnumSaveModeProject, nStatusID: EnumProjectStatusID, sStatusName: string) => {
        // if ((lstFileCloseProject || []).filter(f => !f.isDelete).length === 0) {
        //     return DialogFn.Warning("กรุณาอัพโหลดไฟล์หลักฐาน");
        // }

        let ObjDataForm = form.getValues();        
        let _ObjDataProject = {
            sProjectName : ObjDataProject?.sProjectName, //ชื่อโครงการ < TbProject
            nUnitTypeID : ObjDataProject?.nUnitTypeID, //ID หน่วยงานที่รับผิดชอบ  < TbProject
            sUnitTypeName : ObjDataProject?.sUnitTypeName, //หน่วยงานที่รับผิดชอบ  < TbProject

            //งบประมาณ
            nApproveBudget : ObjDataProject?.nApproveBudget, //งบประมาณที่กองทุนจัดสรรให้ < TbProject
            nProjectBudget : ObjDataProject?.nProjectBudget, //จ่ายจริงทั้งสิ้น < TbProject
            nRemaininBudget : ObjDataProject?.nRemaininBudget, //เงินคงเหลือทั้งสิ้ (คำนวณให้ งบประมาณที่กองทุนจัดสรรให้ - จ่ายจริงทั้งสิ้น = เงินคงเหลือทั้งสิ้น << ถ้ามีเงินคงเหลือ ให้แสดงสีไฮไลท์)

            //ระยะเวลาดำเนินการ
            dProjectStart : ObjDataProject?.dProjectStart, //วัน/เดือน/ปี ที่เริ่มตั้น
            dCloseProject : moment(ObjDataForm.dCloseProject), //วัน/เดือน/ปี ที่สิ้นสุด (กรอกเอง)
            nDateCloseProject : moment(ObjDataForm.dCloseProject).isValid ? ConvertDateToUnixOrNull(moment(ObjDataForm.dCloseProject)) : null, //วัน/เดือน/ปี ที่สิ้นสุด (กรอกเอง)
            nProjectActualDay : Convert.StringToIntOrNull(ObjDataForm.nProjectActualDay), //ระบุจำนวนวัน << จำนวนวันที่ดำนเนินโครงการ (ระบุตอนปิดโครงการ) (กรอกเอง) 

            //สรุปผลการดำเนินงานโครงการ
            sObjectiveDesc : ObjDataProject?.sObjectiveDesc, //วัตถุประสงค์โครงการ < TbProjectData
            sObjectiveTarget : ObjDataProject?.sObjectiveTarget, //เป้าหมายโครงการ < TbProjectData
            sCloseOperatingResults : ObjDataForm.sCloseOperatingResults, //ผลการดำเนินงาน (กรอกเอง) < TbProjectData
            sCloseManageSustainable : ObjDataForm.sCloseManageSustainable, //แนวทางการบริหารโครงการเพื่อให้เกิดความต่อเนื่องและยั่งยืน (กรอกเอง) < TbProjectData

            sCloseIssue : ObjDataForm.sCloseIssue, //ปัญหา/อุปสรรคที่เกิดขึ้นหลังเสร็จสิ้นโครงการ และแนวทางแก้ไข (กรอกเอง) < TbProjectData

            //ชื่อผู้จัดทำรายงาน
            nUserMakeID : ObjDataProject?.nUserMakeID, //ID ชื่อผู้จัดทำรายงาน
            sUserMakeName : ObjDataProject?.sUserMakeName, //ชื่อผู้จัดทำรายงาน
            nUserMakePositionID : ObjDataProject?.nUserMakePositionID, //ID ตำแหน่ง
            nUserMakePositionName : ObjDataProject?.nUserMakePositionName, //ตำแหน่ง

            //ชื่อผู้รับรอง
            nUserCertifierID : ObjDataProject?.nUserCertifierID, //ID ชื่อผู้รับรอง
            sUserCertifierName : ObjDataProject?.sUserCertifierName, //ชื่อผู้รับรอง
            nUserCertifierPositionID : ObjDataProject?.nUserCertifierPositionID, //ID ตำแหน่ง
            nUserCertifierPositionName : ObjDataProject?.nUserCertifierPositionName, //ตำแหน่ง

            lstFileCloseProject: lstFileCloseProject,
        }

        let param = {
            nProjectID: nProjectID,
            sLocation: location.pathname,
            nSaveModeProject: nModeID,
            nStatusID: nStatusID,
            ObjDataProject: _ObjDataProject,
            sRemark: formRemark.getValues("sRemark") ?? null,
        };

        DialogFn.Submit("คุณต้องการ" + sStatusName + "หรือไม่ ?", () => {
            DialogFn.BlockUI();
            AxiosFn.Post(ApiProject.SaveProjectClose, param, (result) => {
                DialogFn.UnBlockUI();
                if (result.nStatusCode === APIStatusCode.Success)
                {
                    DialogFn.Success(sStatusName + "สำเร็จ", () => { 
                        if (nModeID !== EnumSaveModeProject.UpdateFile && nStatusID !== EnumProjectStatusID.nStatusID_35) handleBack(); 
                        if (isEditSecretary && isModeSecretary === true) setisEditSecretary(false);
                    });
                } else {
                    DialogFn.Warning(result.sMessage);                    
                }
            }, (err) => {
                DialogFn.UnBlockUI();
                if (!err.response) {
                    DialogFn.Warning(err.sMessage);
                }
            });
        });
    };

    const handleBack = () => {
        let sNameBack = "/Project";
        let sPathName = Router.GetCurrentRoute();
        if (sPathName === "/projectsrequestingfrom") sNameBack = "/ProjectList";
        navigate(sPathNameBack !== null ? sPathNameBack : sNameBack);
    }
    
    useEffect(() => {
        if (ObjStepFlowProject !== null && sMode !== null) {
            setisEdit(sMode === "UpdateProgress" ? (ObjStepFlowProject?.isPermission_Tab7) : ((ObjStepFlowProject?.isPermission_Tab7 && isModeSecretary) ? true : false));
        }
    }, [ObjStepFlowProject, sMode]);

    return (
        <Grid item xs={12} md={12} container spacing={2} style={{ padding: '2%', paddingBottom: '1%', }}>
            <FormProvider {...form}>
                <Grid id={"myDivClose"} item xs={12} md={12} container spacing={2} justifyContent={'center'}>
                    <Typography variant='h6' color={'#790000'}>แบบรายงานสรุปผลการดำเนินงานเมื่อสิ้นสุดโครงการ แบบ กท. 3/2</Typography>
                </Grid>
                <Grid item xs={12} md={12}>
                    <Divider variant="fullWidth" style={{ color: "#df950973", border: '2px solid', }}/>
                </Grid>  
                <Grid item xs={12} md={12} container spacing={2} style={{ paddingLeft: '2%', paddingBottom: '1%', }}>
                    <Grid item xs={12} md={12} container spacing={2}>
                        <Grid item xs={12} md={3}>
                            <Typography variant='body1' fontWeight="bold">1. ชื่อโครงการ</Typography>
                        </Grid>
                        <Grid item xs={12} md={8} style={{ paddingLeft: '2.5%',}}>
                            <Typography variant='body1'>{ObjDataProject?.sProjectName ?? ""}</Typography>
                        </Grid>
                    </Grid>
                    <Grid item xs={12} md={12} container spacing={2}>
                        <Grid item xs={12} md={3}>
                            <Typography variant='body1' fontWeight="bold">2. หน่วยงานที่รับผิดชอบ</Typography>
                        </Grid>
                        <Grid item xs={12} md={8} style={{ paddingLeft: '2.5%',}}>
                            <Typography variant='body1'>{ObjDataProject?.sUnitTypeName ?? ""}</Typography>
                        </Grid>
                    </Grid>
                    <Grid item xs={12} md={12} container spacing={2}>
                        <Grid item xs={12} md={12}>
                            <Typography variant='body1' fontWeight="bold">3. งบประมาณ</Typography>
                        </Grid>
                        <Grid item xs={12} md={12} container spacing={2} style={{ paddingLeft: '3%',}}>
                            <Grid item xs={12} md={3}>
                                <Typography variant='body1' fontWeight="bold">3.1 งบประมาณที่กองทุนจัดสรรให้</Typography>
                            </Grid>
                            <Grid item xs={12} md={8}>
                                <Typography variant='body1'>{(formatNumber(ObjDataProject?.nApproveBudget  ?? "0", 2)) + " บาท"}</Typography>
                            </Grid>
                            <Grid item xs={12} md={3}>
                                <Typography variant='body1' fontWeight="bold">3.2 จ่ายจริงทั้งสิ้น</Typography>
                            </Grid>
                            <Grid item xs={12} md={8}>
                                <Typography variant='body1'>{(formatNumber(ObjDataProject?.nProjectBudget  ?? "0", 2)) + " บาท"}</Typography>
                            </Grid>
                            <Grid item xs={12} md={3}>
                                <Typography variant='body1' fontWeight="bold">3.3 เงินคงเหลือทั้งสิ้น</Typography>
                            </Grid>
                            <Grid item xs={12} md={8}>
                                <Typography variant='body1'>{(formatNumber(ObjDataProject?.nRemaininBudget  ?? "0", 2)) + " บาท"}</Typography>
                            </Grid>
                        </Grid>
                    </Grid>
                    <Grid item xs={12} md={12} container spacing={2}>
                        <Grid item xs={12} md={12}>
                            <Typography variant='body1' fontWeight="bold">4. ระยะเวลาดำเนินการ</Typography>
                        </Grid>
                        <Grid item xs={12} md={12} container spacing={2} style={{ paddingLeft: '3%',}}>
                            <Grid item xs={12} md={3}>
                                <Typography variant='body1' fontWeight="bold">วัน/เดือน/ปี ที่เริ่มต้น</Typography>
                            </Grid>
                            <Grid item xs={12} md={8}>
                                <Typography variant='body1'>{ObjDataProject?.sDateProjectStart ?? ""}</Typography>
                            </Grid>
                            <Grid item xs={12} md={3} container spacing={1}>
                                <Grid item>
                                    <Typography variant='body1' fontWeight="bold">วัน/เดือน/ปี ที่สิ้นสุด</Typography>
                                </Grid>
                                <Grid item>
                                    <Typography variant='body1' fontWeight="bold" color={'red'}>*</Typography>
                                </Grid>                        
                            </Grid>
                            <Grid item xs={12} md={8}>
                                <Grid item xs={12} md={4}>
                                    <DatePickerItem
                                        id={'dCloseProject'}
                                        name={'dCloseProject'}
                                        label={"วัน/เดือน/ปี ที่สิ้นสุด"}
                                        IsDisplayLabel={false}
                                        required={true}
                                        fullWidth={true}
                                        minDate={dProjectStart}
                                        disabled={(nProgressStatusID === EnumProjectStatusID.nStatusID_28) ? true : !isEdit}
                                        defaultCalendarMonth={moment(dProjectStart)}
                                        IsDisablePortal={true}
                                    />
                                </Grid>
                            </Grid>
                            <Grid item xs={12} md={3} container spacing={1}>
                                <Grid item>
                                    <Typography variant='body1' fontWeight="bold">ระบุจำนวนวัน</Typography>
                                </Grid>
                                <Grid item>
                                    <Typography variant='body1' fontWeight="bold" color={'red'}>*</Typography>
                                </Grid>                        
                            </Grid>
                            <Grid item xs={12} md={8}>
                                <Grid item xs={12} md={4}>
                                    <InputNumberItem
                                        id={"nProjectActualDay"}
                                        name={"nProjectActualDay"}
                                        label={"ระบุจำนวนวัน"}
                                        IsDisplayLabel={false}
                                        required={true}
                                        IsComma={false}
                                        IsAllowScientific={false}
                                        type={"Number"}
                                        ShowDigits={0}
                                        maxDigits={0}
                                        maxInteger={4}
                                        maxLength={4} 
                                        min={0}                
                                        disabled={(nProgressStatusID === EnumProjectStatusID.nStatusID_28) ? true : !isEdit}
                                    />
                                </Grid>
                            </Grid>
                        </Grid>
                    </Grid>
                    <Grid item xs={12} md={12} container spacing={2}>
                        <Grid item xs={12} md={12}>
                            <Typography variant='body1' fontWeight="bold">5. สรุปผลการดำเนินงานโครงการ</Typography>
                        </Grid>
                        <Grid item xs={12} md={12} container spacing={2} style={{ paddingLeft: '3%',}}>
                            <Grid item xs={12} md={3}>
                                <Typography variant='body1' fontWeight="bold">5.1 วัตถุประสงค์โครงการ</Typography>
                            </Grid>
                            <Grid item xs={12} md={8}>
                                <Typography variant='body1'>{ParseHtml(ObjDataProject?.sObjectiveDesc ?? "")}</Typography>
                            </Grid>
                            <Grid item xs={12} md={3}>
                                <Typography variant='body1' fontWeight="bold">5.2 เป้าหมายโครงการ</Typography>
                            </Grid>
                            <Grid item xs={12} md={8}>
                                <Typography variant='body1'>{ParseHtml(ObjDataProject?.sObjectiveTarget ?? "")}</Typography>
                            </Grid>
                            <Grid item xs={12} md={3} container spacing={1}>
                                <Grid item>
                                    <Typography variant='body1' fontWeight="bold">5.3 ผลการดำเนินงาน</Typography>
                                </Grid>
                                <Grid item>
                                    <Typography variant='body1' fontWeight="bold" color={'red'}>*</Typography>
                                </Grid>                        
                            </Grid>
                            <Grid item xs={12} md={8}>
                                <TextAreaItem
                                    id={"sCloseOperatingResults"}
                                    name={"sCloseOperatingResults"}
                                    label={"5.3 ผลการดำเนินงาน"}
                                    IsDisplayLabel={false}                          
                                    required={true}
                                    maxLength={2000}
                                    row={5}
                                    disabled={(nProgressStatusID === EnumProjectStatusID.nStatusID_28) ? true : !isEdit}
                                    placeholder='ระบุผลผลิต ผลลัพธ์ และผลกระทบตามตัวชี้วัดของโครงการ'
                                />
                            </Grid>
                            <Grid item xs={12} md={3} container spacing={1}>
                                <Grid item>
                                    <Typography variant='body1' fontWeight="bold">{ParseHtml("5.4 แนวทางการบริหารโครงการเพื่อให้ <br/> เกิดความต่อเนื่องและยั่งยืน")}</Typography>
                                </Grid>
                                <Grid item>
                                    <Typography variant='body1' fontWeight="bold" color={'red'}>*</Typography>
                                </Grid>                        
                            </Grid>
                            <Grid item xs={12} md={8}>
                                <TextAreaItem
                                    id={"sCloseManageSustainable"}
                                    name={"sCloseManageSustainable"}
                                    label={"5.4 แนวทางการบริหารโครงการเพื่อให้เกิดความต่อเนื่องและยั่งยืน"}
                                    IsDisplayLabel={false}                          
                                    required={true}
                                    maxLength={2000}
                                    row={5}
                                    disabled={(nProgressStatusID === EnumProjectStatusID.nStatusID_28) ? true : !isEdit}
                                />
                            </Grid>
                        </Grid>
                    </Grid>
                    <Grid item xs={12} md={12} container spacing={2}>
                        <Grid item xs={12} md={3} container spacing={1}>
                            <Grid item>
                                <Typography variant='body1' fontWeight="bold">{ParseHtml("6. ปัญหา/อุปสรรคที่เกิดขึ้นหลังเสร็จสิ้น <br/> โครงการ และแนวทางแก้ไข")}</Typography>
                            </Grid>
                            <Grid item>
                                <Typography variant='body1' fontWeight="bold" color={'red'}>*</Typography>
                            </Grid> 
                        </Grid> 
                        <Grid item xs={12} md={8} style={{ paddingLeft: '2.5%',}}>
                            <TextAreaItem
                                id={"sCloseIssue"}
                                name={"sCloseIssue"}
                                label={"6. ปัญหา/อุปสรรคที่เกิดขึ้นหลังเสร็จสิ้น โครงการ และแนวทางแก้ไข"}
                                IsDisplayLabel={false}                          
                                required={true}
                                maxLength={2000}
                                row={5}
                                disabled={(nProgressStatusID === EnumProjectStatusID.nStatusID_28) ? true : !isEdit}
                            />
                        </Grid>
                    </Grid>
                    <Grid item xs={12} md={12} container spacing={2}>
                        <Grid item xs={12} md={3}>
                            <Typography variant='body1' fontWeight="bold">ชื่อผู้จัดทำรายงาน</Typography>
                        </Grid>
                        <Grid item xs={12} md={8} container spacing={1} style={{ paddingLeft: '2.5%',}}>
                            <Grid item xs={12} md={12}>
                                <Typography variant='body1'>{ObjDataProject?.sUserMakeName ?? ""}</Typography>
                            </Grid>
                            <Grid item xs={12} md={12} container spacing={1}>
                                <Grid item>
                                    <Typography variant='body1' fontWeight="bold">ตำแหน่ง</Typography>
                                </Grid>
                                <Grid item>
                                    <Typography variant='body1'>{ObjDataProject?.nUserMakePositionName ?? ""}</Typography>
                                </Grid>
                            </Grid>
                        </Grid>
                    </Grid>
                    <Grid item xs={12} md={12} container spacing={2} style={{ paddingBottom: '1%', }}>
                        <Grid item xs={12} md={3}>
                            <Typography variant='body1' fontWeight="bold">ชื่อผู้รับรอง</Typography>
                        </Grid>
                        <Grid item xs={12} md={8} container spacing={1} style={{ paddingLeft: '2.5%',}}>
                            <Grid item xs={12} md={12}>
                                <Typography variant='body1'>{ObjDataProject?.sUserCertifierName ?? ""}</Typography>
                            </Grid>
                            <Grid item xs={12} md={12} container spacing={1}>
                                <Grid item>
                                    <Typography variant='body1' fontWeight="bold">ตำแหน่ง</Typography>
                                </Grid>
                                <Grid item>
                                    <Typography variant='body1'>{ObjDataProject?.nUserCertifierPositionName ?? ""}</Typography>
                                </Grid>
                            </Grid>
                        </Grid>
                    </Grid>
                    <Grid item xs={12} md={12} container spacing={2} style={{ paddingBottom: '3%', }}>
                        <Grid item >
                            <UploadFileItem
                                required={false}
                                modeDisplay={"list"}
                                id={"oFileCloseProject"}
                                name={"oFileCloseProject"}
                                label={"หมายเหตุ (หลักฐานเอกสารแนบท้าย)"}
                                arrFile={lstFileCloseProject}
                                setarrFile={setlstFileCloseProject}
                                Extension={["pdf", "jpg", "jpeg", "png", "doc", "docx", "xls", "xlsx", "rar", "zip"]}
                                IsFolder={false}
                                onClearFile={onClearFile}
                                sFolderTemp="Project"
                                IsMultiple={true}
                                nLimitFile={30}
                                sLimitFile="MB"
                                sPositionText="right"
                                IsCrop={true}
                                cropShape={"retangle"}
                                cropRatio={16 / 9}
                                cropResize={true}
                                cropMovable={true}
                                // disabled={_isEditSecretary}
                                disabled={(nProgressStatusID === EnumProjectStatusID.nStatusID_28 && isEditSecretary === true) ? false : !isEdit}
                            />
                        </Grid>
                    </Grid> 
                    <Grid item xs={12} md={12} container spacing={2} style={{ paddingBottom: '1%', }}>
                        <ContentWrapper
                            style={{
                                border: '0px solid #f1f1f1 !important',
                                borderRadius: '10px',
                                paddingBottom: '1%',
                                padding: '2%',
                                backgroundColor: '#fffbee6e',
                            }}
                        >
                            <Grid item xs={12} md={12} container spacing={2}>
                                <Grid item xs={12} md={12} container spacing={2}>
                                    <Grid item xs={12} md={12}>
                                        <Typography variant='body1' style={{ textDecoration: "underline" }}>หลักฐานประกอบสำหรับการดำเนินงานสิ้นสุดโครงการ</Typography>
                                    </Grid>
                                    <Grid item xs={12} md={12} container spacing={1} justifyContent="end">
                                        <Grid item xs={12} md={11.8}>
                                            <Grid item>
                                                <Typography variant='body2'>{"1. (ร่าง)​ รายงานวิจัยฉบับสมบูรณ์ (เฉพาะโครงการตามมาตรา 40 (3)​ เท่านั้น)"}</Typography>
                                            </Grid>
                                            <Grid item>
                                                <Typography variant='body2'>{"2. Onepage หรือโปสเตอร์  1 ฉบับ"}</Typography>
                                            </Grid>
                                            <Grid item>
                                                <Typography variant='body2'>{"3. สไลด์นำเสนอสรุปผลการดำเนินงานโครงการ"}</Typography>
                                            </Grid>
                                            <Grid item>
                                                <Typography variant='body2'>{"4. รายงานสำหรับผู้บริหาร (ไม่เกิน 10 หน้า)"}</Typography>
                                            </Grid>
                                            <Grid item>
                                                <Typography variant='body2'>{"5. ผลผลิตจากการดำเนินโครงการหรือเอกสารเพิ่มเติมอื่น ๆ"}</Typography>
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                </Grid>
                                <Grid item xs={12} md={12} container spacing={2}>
                                    <Grid item xs={12} md={12}>
                                        <Typography variant='body1' style={{ textDecoration: "underline" }}>หมายเหตุ</Typography>
                                    </Grid>
                                    <Grid item xs={12} md={12} container spacing={1} justifyContent="end">
                                        <Grid item xs={12} md={11.8}>
                                            <Grid item>
                                                <Typography variant='body2'>{"1. ผู้รับรองต้องเป็นผู้มีอำนาจมากกว่าผู้จัดทำรายงานหนี่งระดับ"}</Typography>
                                            </Grid>
                                            <Grid item>
                                                <Typography variant='body2'>{ParseHtml("2. หากมีหลักฐาน เช่น แบบทดสอบ แบบสำรวจความพึงพอใจ แผ่นพับ การนำเสนอผลงาน การตีพิมพ์ผลงาน หนังสือข้อความอนุเคราะห์ที่เกี่ยวข้องกับการนำเสนอหรือขอข้อมูลต่างๆ ของโครงการ และ/หรือ การเผยแพร่ผลงานบนสื่อสังคมออนไลน์ให้ส่งเป็น เอกสารแนบท้ายแบบ กท. ๓/๒")}</Typography>
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                </Grid>
                            </Grid>
                        </ContentWrapper>
                    </Grid> 
                    {(nProgressStatusID === EnumProjectStatusID.nStatusID_28 && isModeSecretary === true) ?
                        <Grid item xs={12} md={12} container spacing={1} justifyContent="end">
                            {isEditSecretary === false ?
                                <Grid item>
                                    <BtnEdit id={"btnEdit_QuaterClose"}  txt={I18n.SetText("Button.Edit", I18NextNs.labelComponent)} onClick={() => { setisEditSecretary(true); document.getElementById("myDivClose").scrollIntoView({ behavior: "smooth" }); }} />
                                </Grid>
                                :
                                <>
                                    <Grid item>
                                        <BtnCancel id={"btnCancel_QuaterClose"} txt={I18n.SetText("Button.Cancel", I18NextNs.labelComponent)} onClick={() => { setisEditSecretary(false); GetFormInitial(); }} />
                                    </Grid>
                                    <Grid item>
                                        <BtnSendRequest id={"btnSend_QuaterClose"} txt={I18n.SetText("Button.Save", I18NextNs.labelComponent)} onClick={(e) => { handleSubmit(EnumSaveModeProject.UpdateFile, 0, I18n.SetText("Button.Save", I18NextNs.labelComponent)) }} />
                                    </Grid>
                                </>
                            }   
                        </Grid>
                        :
                        ((isEdit || (nProgressStatusID === EnumProjectStatusID.nStatusID_26 && isModeSecretary === true)) && 
                            <Grid item xs={12} md={12} container spacing={2} justifyContent="center" style={{ paddingBottom: '1%', }}>
                                {/* ปิดโครงการ
                                    isBtn_DraftClose << Requester | ผู้ประสานงาน | เลขา >> บันทึกร่าง
                                    isBtn_SendClose << Requester | ผู้ประสานงาน | เลขา >> หัวหน้าโครงการ >> บันทึกปิดโครงการ
                                    isBtn_ConfirmSendClose << หัวหน้าโครงการ >> ยืนยันปิดโครงการ
                                    isBtn_SendEditClose << เลขา >> ส่งกลับแก้ไข < ทั้งรายงานผลไตรมาสสุดท้ายกับปิดโครงการ << Requester | ผู้ประสานงาน | เลขา | หัวหน้าโครงการ
                                    isBtn_ConfirmClose << เลขา >> ยอมรับผลและปิดโครงการ 
                                */}
                                {ObjStepFlowProject?.isBtn_DraftClose && 
                                    //isBtn_DraftClose << Requester | ผู้ประสานงาน | เลขา >> บันทึกร่าง
                                    <Grid item>
                                        <BtnDraft 
                                            id="BtnDraft_Close"
                                            txt={I18n.SetText("Button.Draft", I18NextNs.labelComponent)}
                                            onClick={form.handleSubmit((e) => handleSubmit(EnumSaveModeProject.Draft, EnumProjectStatusID.nStatusID_35, I18n.SetText("Button.Draft", I18NextNs.labelComponent)),(err) => {
                                                document.getElementById(Object.keys(err)[0])?.focus();
                                                console.log("err", err);
                                            })}
                                        />
                                    </Grid>
                                }
                                {ObjStepFlowProject?.isBtn_SendClose && 
                                    //isBtn_SendClose << Requester | ผู้ประสานงาน | เลขา >> หัวหน้าโครงการ >> บันทึกปิดโครงการ
                                    <Grid item>
                                        <BtnSave 
                                            id="BtnSubmit_Close"
                                            txt={"บันทึกปิดโครงการ"}
                                            onClick={form.handleSubmit((e) => handleSubmit(EnumSaveModeProject.Submit, EnumProjectStatusID.nStatusID_25, "บันทึกปิดโครงการ"),(err) => {
                                                document.getElementById(Object.keys(err)[0])?.focus();
                                                console.log("err", err);
                                            })}
                                        />
                                    </Grid>
                                }
                                {ObjStepFlowProject?.isBtn_ConfirmSendClose && 
                                    //isBtn_ConfirmSendClose << หัวหน้าโครงการ >> ยืนยันปิดโครงการ
                                    <Grid item>
                                        <BtnSave 
                                            id="BtnConfirmSend_Close"
                                            txt={"ยืนยันปิดโครงการ"}
                                            onClick={form.handleSubmit((e) => handleSubmit(EnumSaveModeProject.Submit, EnumProjectStatusID.nStatusID_26, "ยืนยันปิดโครงการ"),(err) => {
                                                document.getElementById(Object.keys(err)[0])?.focus();
                                                console.log("err", err);
                                            })}
                                        />
                                    </Grid>
                                }
                                {(ObjStepFlowProject?.isBtn_SendEditClose && isModeSecretary === true) &&
                                    //isBtn_SendEditClose << เลขา >> ส่งกลับแก้ไข < ทั้งรายงานผลไตรมาสสุดท้ายกับปิดโครงการ << Requester | ผู้ประสานงาน | เลขา | หัวหน้าโครงการ
                                    <Grid item>
                                        <BtnEdit
                                            id="BtnRecall_Close"
                                            txt={I18n.SetText("Button.SendEdit", I18NextNs.labelComponent)}
                                            // IsDisabled={!isEdit}
                                            // onClick={form.handleSubmit((e) => handleSubmit(EnumSaveModeProject.Reject, EnumProjectStatusID.nStatusID_27, I18n.SetText("Button.SendEdit", I18NextNs.labelComponent)),(err) => {
                                            //     document.getElementById(Object.keys(err)[0])?.focus();
                                            //     console.log("err", err);
                                            // })}
                                            onClick={(e)=>{ setisModalRecallClose(true); }}
                                        />
                                    </Grid>
                                }
                                {(ObjStepFlowProject?.isBtn_ConfirmClose && isModeSecretary === true) &&
                                    //isBtn_ConfirmClose << เลขา >> ยอมรับผลและปิดโครงการ 
                                    <Grid item>
                                        <BtnApprove
                                            id="BtnConfirm_Close"
                                            txt={"ยอมรับผลและปิดโครงการ"}
                                            onClick={form.handleSubmit((e) => handleSubmit(EnumSaveModeProject.Approve, EnumProjectStatusID.nStatusID_28, "ยอมรับผลและปิดโครงการ"),(err) => {
                                                document.getElementById(Object.keys(err)[0])?.focus();
                                                console.log("err", err);
                                            })}
                                        />
                                    </Grid>
                                }
                            </Grid>
                        )
                    }
                </Grid>

                {/* {isModalRecallClose && 
                    <ModalRemark
                        isOpenRemark={isModalRecallClose} 
                        setIsOpenRemark={setisModalRecallClose} 
                        sRemark={sRemark} 
                        setsRemark={setsRemark} 
                        onSubmit={form.handleSubmit((e) => handleSubmit(EnumSaveModeProject.Reject, EnumProjectStatusID.nStatusID_27, I18n.SetText("Button.SendEdit", I18NextNs.labelComponent)),(err) => {
                            document.getElementById(Object.keys(err)[0])?.focus();
                            console.log("err", err);
                        })} 
                    /> 
                } */}
                <DialogPreview
                    IsOpen={isModalRecallClose}
                    Title={"ส่งกลับแก้ไข"}
                    onClose={() => { setisModalRecallClose(false); formRemark.reset();}}
                    sMaxWidth='xs'
                    CloseSave={true}
                >
                    <FormProvider {...formRemark}>
                        <TextAreaItem
                            label={""}
                            id={`sRemark`}
                            name={`sRemark`}
                            row={4}
                            required={isModalRecallClose}
                            maxLength={500}
                        />
                        <Stack direction={"row"} justifyContent={"end"} sx={{ width: "100%", mt: 2, mb: 1 }}>
                            <BtnSave 
                                id={"btnSave"} 
                                onClick={formRemark.handleSubmit((e) => handleSubmit(EnumSaveModeProject.Reject, EnumProjectStatusID.nStatusID_27, I18n.SetText("Button.SendEdit", I18NextNs.labelComponent)),(err) => {
                                    document.getElementById(Object.keys(err)[0])?.focus();
                                    console.log("err", err);
                                })}
                            />
                        </Stack>
                    </FormProvider>
                </DialogPreview>
                
            </FormProvider>
        </Grid>       
    )
}
export default CloseProject;